import { Link } from "react-router-dom";

const quickLinks = [
  { label: "人物档案库", to: "/renwu" },
  { label: "关于我们", to: "/guanyu" },
  { label: "追踪方法", to: "/#method" },
  { label: "常见问题", to: "/#faq" },
];

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-accent-900">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-8 w-8 items-center justify-center bg-background-50/10 text-background-50">
                <i className="ri-user-search-line text-lg"></i>
              </span>
              <span className="font-display text-lg font-bold text-background-50">
                焦点人物志
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-50/80">
              专注最新爆料中的人物追踪：以人物档案的方式，逐一厘清每一桩热点背后的新主角、新面孔、新涉事者与新当事人，还原爆料全貌与最新动态。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold uppercase tracking-widest text-background-50/60">
              站内导航
            </h3>
            <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-3">
              {quickLinks.map((l) => (
                <li key={l.label}>
                  <Link
                    to={l.to}
                    className="whitespace-nowrap text-sm text-background-50/80 transition-colors hover:text-background-50"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold uppercase tracking-widest text-background-50/60">
              追踪原则
            </h3>
            <ul className="mt-4 space-y-2.5 text-sm text-background-50/80">
              <li className="flex items-center gap-2">
                <i className="ri-shield-check-line text-background-50/70"></i>
                只标注，不预判
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-file-search-line text-background-50/70"></i>
                材料可交叉验证
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-refresh-line text-background-50/70"></i>
                随进展持续更新
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-50/15 pt-6 sm:flex-row">
          <p className="text-xs text-background-50/60">
            © 2026 焦点人物志 · 本栏目内容仅供信息梳理与阅读参考
          </p>
          <p className="text-xs text-background-50/60">
            联系邮箱：contact@focuspeople.example
          </p>
        </div>
      </div>
    </footer>
  );
}